import React from 'react';
import { Badge } from '../ui/Badge';
import { Priority } from '../../types/task';
interface PriorityBadgeProps {
  priority: Priority;
}
export const PriorityBadge = ({
  priority
}: PriorityBadgeProps) => {
  switch (priority) {
    case 'high':
      return <Badge variant="error" data-id="element-133">High</Badge>;
    case 'medium':
      return <Badge variant="warning" data-id="element-134">Medium</Badge>;
    case 'low':
      return <Badge variant="success" data-id="element-135">Low</Badge>;
    default:
      return <Badge data-id="element-136">Unknown</Badge>;
  }
};